import { TestIdDomain } from 'constants/testIds';

export const LoanTabLayoutTestIds = {
  // BottomBtnGroup
  NEXT_STEP_BUTTON: `${TestIdDomain.LOAN}.next-step-button`,
  PREVIOUS_STEP_BUTTON: `${TestIdDomain.LOAN}.previous-step-button`,

  // LoanTabLayout
  LAYOUT_HEADER: `${TestIdDomain.LOAN}.header`,
};
